import { type TComment, getProjectCommentsUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

/**
 * Fetch the flat comment list for a project. Replies are embedded eagerly via `expand=replies`
 * (nextjs parity). Mirrors {@link getAudioComments}; the read path is selected by `entityType` in
 * {@link useComments}.
 */
export const getProjectComments = (id: string, signal?: AbortSignal) => {
    return httpClient
        .get(withQuery(getProjectCommentsUrl(id), { expand: 'replies' }), { signal })
        .json<TComment[]>()
}
